import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { DatadogService } from '../../service';

export type ListLogIndexesConfig = typeof ListLogIndexesConfig._.Config;

export const ListLogIndexesConfig = IntegrationConfig.make({
  service: DatadogService,
  name: Integration_Handler_Names_Enum.ListLogIndexes,
  configSchema: z.object({
    minimumRetentionPeriodInDays: z.number().min(0).optional(),
    indexNamePatternFilter: patternFilterSchema.optional(),
  }),
});
